import module from '../module';
import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';

import scopeUtils from '../../../utils/scope';

function OrderCheckoutController($scope, cartService, session, $state, checkoutService, messageService) {

    this.$onInit = async () => {
        await $scope.init();
    };

    $scope.paymentSystemReady = false;
    $scope.config = {};
    $scope.paymentSystem = '';

    // $scope.$watch('paymentSystem', async paymentSystem => {
    $scope.paymentSystemChanged = async (paymentSystem) => {

        paymentSystem = paymentSystem || $scope.paymentSystem;

        if (!paymentSystem) {
            $scope.paymentSystemReady = false;
            $scope.paymentError = '';
            return;
        }

        $scope.paymentSystemReady = false;
        $scope.paymentError = '';
        scopeUtils.apply($scope);

        try {
            const paymentConfiguration = await checkoutService.beginCheckout(paymentSystem);

            switch (paymentSystem) {
                case 'PayPal':
                    $scope.clientToken = paymentConfiguration.clientToken;
                    break;
                case 'Square':
                    break;
            }
            $scope.paymentSystemReady = true;
        } catch (error) {
            $scope.paymentError = messageService.getMessageFromErrorResponse(error);
            $scope.paymentSystemReady = false;
        } finally {
            scopeUtils.apply($scope);
        }
    };

    //); // end $scope.$watch

    $scope.pay = async () => {

        if ($scope.paymentSystem === 'PayPal') {
            window.location.href = Constants.PAYPAL_CHECKOUT_URL + $scope.clientToken;
            return;
        }

        $scope.paymentSystemReady = false;
        $scope.paymentError = '';
        scopeUtils.apply($scope);

        try {

            const cardData = await $scope.config.getCardNonce();
            cardData.orderTotal = $scope.orderTotal;
            cardData.isAuthorization = false;
            await checkoutService.submitOrder($scope.paymentSystem, cardData);
            $state.go(Constants.RoutingStates.CONFIRM_ORDER);
        } catch (error) {
            $scope.paymentError = "client.payment.credit_trans_not_approved";
            $scope.paymentSystemReady = true;
            scopeUtils.apply($scope);
        }
    };

    $scope.init = async () => {
        const cart = await cartService.getCart();

        if (cart.items.length === 0) {
            $scope.showCatalog();
            return;
        }

        $scope.groupOrder = cartService.isGroupOrder(cart);

        let userEmail = await session.getUserEmail();

        $scope.orderTotal = 0;

        if (cart.fulfillment.paymentMethod == "single") {
            $scope.orderTotal = cart.cartTotal;
        } else {
            _.each(cart.items, function (item) {
                if (!userEmail || item.participantEmail == userEmail) {
                    $scope.orderTotal += item.price * item.quantity;
                }
            });
        }
    };
}

module.controller('Cartonomy.Order.CheckoutController', ['$scope', 'CartService', 'Session', '$state', 'CheckoutService', 'Message', OrderCheckoutController]);


// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderCheckoutController.js